import React from 'react';
import { useNavigate } from 'react-router-dom';

const NewsCard = ({ news, isLarge = false, showExcerpt = false, isNewsAll }) => {
  const navigate = useNavigate();
  const cardClass = isLarge ? 'news-card-large' : 'news-card-small';
  const titleTag = isLarge ? 'h5' : 'h6';

  const handleCardClick = () => {
    navigate(`/news/${news.id}`);
  };
  
  return (
    <div 
      className={`card news-card ${cardClass} h-100 ${isLarge ? '' : 'd-flex flex-row'} ${isNewsAll ? 'flex-column' : ''}`}
      onClick={handleCardClick}
      style={{ cursor: 'pointer' }}
    >
      <div className={`card-img-wrapper ${isLarge ? '' : 'col-md-6'} ${isNewsAll ? 'col-md-12 h-50' : ''}`}>
        <img
          src={news.image}
          className={`card-img-top`}
          alt={news.title}
        />
      </div>
      <div className={`card-body ${isLarge ? 'd-flex flex-column' : ''} d-flex flex-column`}>
        <small className="text-muted news-date">
          {news.date}
        </small>
        {React.createElement(titleTag, {
          className: "card-title news-title"
        }, news.title)}
      </div>
    </div>
  );
};

export default NewsCard;